<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>

export default {
  name: 'App'
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #cfcd2a;
  width: 100%;
  height: 100%;
  background-color: #333;
  margin: 0px 0px 0px 0px;
}
html {
  background-color: #333;
}
</style>
